import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {renderToString} from 'react-dom/server';
import EntityDataGraphViewProp from './properties/entity-datagraph-view';
import EntityView from './entity-view';
import Api from '../services/api';
import FullScreenLoader from './full-screen';
import EmptyView from './empty-view';
import EntityModel from '../models/entity';
import {EntityTypeEnum} from '../enums/EntityTypeEnum';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function EntityDataGraphView({
                                 setStatusMessage, graphDefinition,
                             }: EntityDataGraphViewProp, ref: React.Ref<any>) {
    const [graphData, setGraphData] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const getEntityGraphView = (dataGraph: any, id: string): string => {
        let view = '';
        view += `<div class="${`ps-${String((id.length / 3 - 1) * 3)}`}">`;
        view += renderToString(<EntityView id={`entity${id}`} data={dataGraph} setStatusMessage={() => {
        }}/>);
        let i = 100;
        Object.keys(dataGraph).forEach((key) => {
            if (key.toLowerCase().includes('joinedentity') || key.toLowerCase().includes('brotherentity')) {
                i += 1;
            }
            if (key.toLowerCase().includes('joinedentity')) {
                const data: EntityModel = dataGraph[key];
                data.type = EntityTypeEnum.joined;
                view += getEntityGraphView(dataGraph[key], id + String(i));
            }

            if (key.toLowerCase().includes('brotherentity')) {
                const data: EntityModel = dataGraph[key];
                data.type = EntityTypeEnum.brother;
                view += getEntityGraphView(dataGraph[key], id + String(i));
            }
        });

        view += '</div>';

        return view;
    };
    const renderGraphView = (dataGraph: any): string => {
        let html = '';
        let id = 100;
        Object.keys(dataGraph).forEach((key) => {
            id += 1;
            html += (getEntityGraphView(dataGraph[key], String(id)));
        });

        return html;
    };

    useImperativeHandle(ref, () => ({
        refresh() {
            setIsLoading(true);
            Api.getDataGraph({...graphDefinition, limit: 10, offset: 0})
                .then((result) => {
                    setIsLoading(false);
                    setGraphData(renderGraphView(result.data));
                })
                .catch((reason) => {
                    setIsLoading(false);
                    setStatusMessage(reason.message, StatusMessageTypeEnum.error);
                });
        },
    }));

    return (
        <div className="p-3">
            {isLoading ? <FullScreenLoader/> : <div/>}
            {graphData?.length > 0
                ? <div dangerouslySetInnerHTML={{__html: graphData}}/> :
                <EmptyView title="Data not found" desc="Could not find any data related to current verb/target pair."/>}
        </div>
    );
}

export default forwardRef(EntityDataGraphView);
